<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <vs-card class="mb-6">
      <form role="form" @submit.stop.prevent="buscar">
        <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
        <div :class="`vx-row ${filtroAvancado == true ? 'mb-3' : 'pb-9 mb-2'}`">
          <div class="vx-col sm:w-1/2 w-full">
            <span>Data Inicial</span>
            <datepicker
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataInicial"
              use-utc="true"
            ></datepicker>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <span>Data Final</span>
            <datepicker
              :format="'dd/MM/yyyy'"
              placeholder="DD/MM/YYYY"
              v-model="formFiltro.dataFinal"
              use-utc="true"
            ></datepicker>
          </div>

          <div v-if="filtroDivisao == true" class="vx-col sm:w-1/4 w-full mt-4">
            <span>Divisões</span>
            <v-select
              :options="divisoes"
              name="Divisao"
              id="Divisao"
              v-model="formFiltro.divisao"
              :state="validateState('Divisao')"
              :class="validateClass('Divisao')"
            ></v-select>
          </div>
          <div
            v-if="filtroRegional == true"
            class="vx-col sm:w-1/4 w-full mt-4"
          >
            <span>Regionais</span>
            <v-select
              :options="regionais"
              name="Regional"
              id="Regional"
              v-model="formFiltro.regional"
              :state="validateState('Regional')"
              :class="validateClass('Regional')"
            ></v-select>
          </div>
          <div
            v-if="filtroAvancado == true && financeiro == true"
            class="vx-col sm:w-1/4 w-full mt-4"
          >
            <span>Status</span>
            <v-select
              :options="status"
              name="status"
              id="status"
              v-model="formFiltro.status"
              :state="validateState('status')"
              :class="validateClass('status')"
            ></v-select>
          </div>
        </div>
      </form>
      <div slot="footer" style="margin-top: -3%">
        <br style="clear: both" />
        <vs-row vs-justify="flex-end">
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            native-type="submit"
            @click="buscar"
            >Buscar</vs-button
          >
          <vs-button
            @click="filtroAvancado = !filtroAvancado"
            type="gradient"
            color="dark"
            icon-pack="feather"
            icon="icon-sliders"
          ></vs-button>
          <vs-button
            @click="limparFiltro"
            color="danger"
            type="gradient"
            icon-pack="feather"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import ability from '../../services/ability';
import jwt from 'jsonwebtoken';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    vistoria: {
      type: Boolean,
    },
    b2c: {
      type: Boolean,
    },
    filtroDivisao: {
      type: Boolean,
    },
    filtroRegional: {
      type: Boolean,
    },
    financeiro: {
      type: Boolean,
    },
  },
  watch: {
    estado(value) {
      this.formFiltro.estado = value;
      this.formFiltro.cidade = null;
      if (value != null) {
        this.buscaDadosSelectsCidades(
          'domMunicipio',
          'cidades',
          'nomeCidade',
          'idCidade',
        );
      }
    },
  },
  data() {
    return {
      filtroAvancado: false,
      idEmpresa: null,
      estados: [],
      cidades: [],
      setores: [],
      divisoes: [],
      regionais: [],
      status: [],
      languages: lang,
      estado: null,
      formFiltro: {
        idEmpresa: null,
        cidade: '',
        estado: '',
        dataInicial: null,
        dataFinal: null,
        setor: null,
        nome: '',
        status: null,
      },
    };
  },
  methods: {
    limparFiltro() {
      this.formFiltro = {
        idEmpresa: null,
        cidade: '',
        estado: '',
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        setor: null,
        nome: '',
      };
      this.preparaDatas();
      this.buscar();
    },
    dataInicio() {
      var a = new Date();
      var b = a.setDate(a.getDate() - 30);
      return b;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          const token = localStorage.getItem('user-token');
          const decoded = jwt.decode(token);
          const permissoes = ability.getPermission().$;

          const carteiraRegional = permissoes.filter(
            (item) =>
              item.subject == 'Associados' &&
              item.action == 'Leitura Carteira Corretora',
          );

          const regionais = [];
          decoded.regionais.map((item) => {
            regionais.push(item.id_regional);
          });
          regionais.push(decoded.id_regional);
          if (array == 'regionais' && carteiraRegional.length > 0) {
            res.data.forEach((element) => {
              if (regionais.includes(element[campoPK])) {
                element.id = element[campoPK];
                element.label = element[campoDescricao];
                if (!element.deletedAt) this[array].push(element);
              }
            });
          } else {
            res.data.forEach((element) => {
              element.id = element[campoPK];
              element.label = element[campoDescricao];
              if (!element.deletedAt) this[array].push(element);
            });
          }
        });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          if (array == 'status' && this.vistoria == true) {
            if (
              element[campoPK] == 3 ||
              element[campoPK] == 4 ||
              element[campoPK] == 5 ||
              element[campoPK] == 7
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
    },
    buscaDadosSetor() {
      service
        .getAll('Setor', {}, 'list/idEmpresa=' + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            this.setores.push({
              id: element.idSetor,
              label: element.nomeSetor,
            });
          });
        });
    },
    preparaDatas() {
      this.formFiltro.dataInicial = moment()
        .startOf('month')
        .format('YYYY-MM-DD');

      this.formFiltro.dataFinal = moment().endOf('month').format('YYYY-MM-DD');
    },

    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      this.$vs.loading();
      this[array] = [];
      service
        .getAll('g', {}, `${model}/list/codUf/${this.formFiltro.estado.id}`)
        .then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });

          this.$vs.loading.close();
        });
    },
    buscar() {
      this.formFiltro.idEmpresa = this.idEmpresa;
      this.$emit('filtro', this.formFiltro);
    },
  },
  mounted() {
    this.preparaDatas();
    this.buscaDadosSelectsPorEmpresa(
      'divisoes',
      'divisoes',
      'nomeDivisao',
      'idDivisao',
    );
    this.buscaDadosSelectsPorEmpresa(
      'regionais',
      'regionais',
      'nome',
      'idRegional',
    );
    this.buscaDadosSelects(
      'domStatusCotacao',
      'status',
      'nomeStatus',
      'idStatus',
    );
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize('ptBr', locale);
  },
  components: {
    Datepicker,
    'v-select': vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style>
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}
</style>
